<template>
    <div
        class="custom-button"
        @click="clickHandler"
    >
        RESET
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    methods: {
        clickHandler(){
            this.$emit("click");
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/classes';

.custom-button{
    text-align: center;
    background-color: grey;
    /*border-radius: 3px;*/
    /*border: 1px solid var(--pallete_main_color);*/
    color: #d3d3d3;
    cursor: pointer;
    user-select: none;
    width: 100%;
    height: 45px;
    line-height: 45px;
    transition: all 100ms ease-in-out;

    &.active {
        background-color: var(--pallete_main_color);
        color: #ffffff;
        box-shadow: 1px 1px 3px rgba(0, 0, 0, .5);
    }

    &:hover {
        background-color: var(--pallete_main_color);
        -webkit-transition: background-color 500ms linear;
        -ms-transition: background-color 500ms linear;
        transition: background-color 500ms linear;
    }
}
</style>
